<ion-header class="ion-no-padding ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" color="dark" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding-horizontal">
  <h3 class="ion-text-center">
    {{ "modals.priviliges_modal.header" | translate }}
  </h3>
  <p class="desc-text">{{ "modals.priviliges_modal.privileged_group_message" | translate }}</p>
  <p>{{ "modals.priviliges_modal.start_exploring" | translate }}</p>
  <ul class="font14">
    <li>{{ "modals.priviliges_modal.premium_club_access" | translate }}</li>
    <li>{{ "modals.priviliges_modal.xclusive_experiences" | translate }}</li>
    <li>{{ "modals.priviliges_modal.airport_privileges" | translate }}</li>
    <li>{{ "modals.priviliges_modal.signature_stays" | translate }}</li>
    <li>{{ "modals.priviliges_modal.curated_deals" | translate }}</li>
    <li>{{ "modals.priviliges_modal.xtraordinary_birthday" | translate }}</li>
  </ul>
</ion-content>